export const AwsMixin = {
    data: () => ({
        images: [],
        isVerticalPhotosInitialized: false,
        isHorizontalPhotosInitialized: false,
    }),
    methods: {
        getImagesFromS3Bucket(folder, type = 'background', saveProp = 'images') {
            const { AWS } = window;
            const {
                VUE_APP_AWS_S3_BUCKET_NAME,
                VUE_APP_AWS_REGION,
                VUE_APP_AWS_IDENTITY_POOL_ID,
                VUE_APP_AWS_ACCESS_KEY,
                VUE_APP_AWS_SECRET_ACCESS_KEY
            } = process.env;

            const AWSS3Config = {
                apiVersion: "latest",
                params: { Bucket: VUE_APP_AWS_S3_BUCKET_NAME },
                secretAccessKey: VUE_APP_AWS_SECRET_ACCESS_KEY,
                accessKeyId: VUE_APP_AWS_ACCESS_KEY
            };

            AWS.config.region = VUE_APP_AWS_REGION; // Region
            AWS.config.credentials = new AWS.CognitoIdentityCredentials({
                IdentityPoolId: VUE_APP_AWS_IDENTITY_POOL_ID
            });
        
            const s3 = new AWS.S3(AWSS3Config);
            const self = this;
            const PORTFOLIO_PHOTOS_FOLDER = folder;
        
            s3.listObjects({ Prefix: PORTFOLIO_PHOTOS_FOLDER }, function(err, data) {
                if (err) {
                    return;
                } else {
                    data.Contents.filter(({ Size }) => Size > 0).forEach((photo, index) => {
                        const bucketUrl =
                            this.request.httpRequest.endpoint.href +
                            VUE_APP_AWS_S3_BUCKET_NAME +
                            "/";
                        const photoUrl = bucketUrl + photo.Key;                        
                        const resultPhoto = type === 'background' ? 
                        {
                            background: photoUrl,
                            size: `1920x1280`,
                            isLoaded: true
                        } : 
                        { url: photoUrl }
        
                        self.$set(self[saveProp], index, resultPhoto);
                    });
                    
                    folder.includes("vertical") && (self.isVerticalPhotosInitialized = true);
                    folder.includes("horizontal") && (self.isHorizontalPhotosInitialized = true);

                    self.isHorizontalPhotosInitialized && self.isHorizontalPhotosInitialized && (self.isResourcesLoaded = true);
                }
            });
        }
    },
}